module.exports = __webpack_public_path__ + "img/zijinjianguan.dc8bfdbc.jpg";